import Vue from "vue";
import ETimePicker from "@/components/ETimePicker.vue";
import ELabel from "@/components/ELabel.vue";
import EUserAvatar from "@/components/Users/EUserAvatar.vue";
import EUserRole from "@/components/Users/EUserRole.vue";
import EUserSituacao from "@/components/Users/EUserSituacao.vue";
import EUserDataBloq from "@/components/Users/EUserDataBloq.vue";
import EModal from "@/components/EModal.vue";
import ELoader from "@/components/ELoader.vue";
import EAutocomplete from "@/components/EAutocomplete.vue";
import EModalInfo from "@/components/EModalInfo.vue";
import EDatePicker from "@/components/EDatePicker.vue";
import EDateCustomize from "@/components/EDateCustomize.vue";
import ESenhaFracaAlert from "@/components/ESenhaFracaAlert.vue";
import EChangePasswordModal from "@/components/EChangePasswordModal.vue";
import ESelecionarFranquiaModal from "@/components/ESelecionarFranquiaModal.vue";
import EmodalConfirm from "@/components/EmodalConfirm.vue";
import EFranquiaSnippetCard from "@/components/Franquias/EFranquiaSnippetCard.vue";
import EModalSelectMonths from "@/components/EModalSelectMonths.vue";
import EModalBoletimFranquia from "@/components/Franquias/EModalBoletimFranquia.vue";
import EModalFaltaAlunoFranquia from "@/components/Franquias/EModalFaltaAlunoFranquia.vue";
import MainTemplate from "@/Pages/Templates/MainTemplate/index.vue";
import ELeftMenu from "@/components/ELeftMenu.vue";
import EPaginate from "@/components/EPaginate.vue";
import EModalDinamic from "@/components/EModalDinamic.vue";
import ENotificacoesList from "@/components/ENotificacoesList.vue";
import ETemaToggle from "@/components/ETemaToggle.vue";
import EDataComemorativaTema from "@/components/EDataComemorativaTema.vue";
import EDataComemorativaSaudacao from "@/components/EDataComemorativaSaudacao.vue";
import EModalVisualizarEvento from "@/components/Calendario/EModalVisualizarEvento.vue";
import EDatePickerCalendarioLetivo from "@/components/EDatePickerCalendarioLetivo.vue";

Vue.component("e-time-picker", ETimePicker);
Vue.component("e-label", ELabel);
Vue.component("e-user-avatar", EUserAvatar);
Vue.component("e-user-role", EUserRole);
Vue.component("e-user-situacao", EUserSituacao);
Vue.component("e-user-data-bloqueio", EUserDataBloq);
Vue.component("e-modal", EModal);
Vue.component("e-modal-confirm", EmodalConfirm);
Vue.component("e-loader", ELoader);
Vue.component("e-autocomplete", EAutocomplete);
Vue.component("e-date-picker", EDatePicker);
Vue.component("e-date-customize", EDateCustomize);
Vue.component("e-senha-fraca-alert", ESenhaFracaAlert);
Vue.component("e-change-password-modal", EChangePasswordModal);
Vue.component("e-selecionar-franquia-modal", ESelecionarFranquiaModal);
Vue.component("e-franquia-snippet-card", EFranquiaSnippetCard);
Vue.component("e-select-months-modal", EModalSelectMonths);
Vue.component("e-modal-boletim-franquia", EModalBoletimFranquia);
Vue.component("e-modal-falta-aluno-franquia", EModalFaltaAlunoFranquia);
Vue.component("main-template", MainTemplate);
Vue.component("e-left-menu", ELeftMenu);
Vue.component("e-paginate", EPaginate);
Vue.component("e-modal-dinamic", EModalDinamic);
Vue.component("e-modal-info", EModalInfo);
Vue.component("e-notificacoes-list", ENotificacoesList);
Vue.component("e-tema-toggle", ETemaToggle);
Vue.component("e-data-comemorativa-tema", EDataComemorativaTema);
Vue.component("e-data-comemorativa-saudacao", EDataComemorativaSaudacao);
Vue.component("e-modal-visualizar-evento", EModalVisualizarEvento);
Vue.component("e-date-picker-calendario-letivo", EDatePickerCalendarioLetivo);
